import * as Images from './Images';
import {LARGE, MEDIUM, SMALL, SMALL_COLOR} from './IconSize';
export const CDN_URL = '//csvcus.homeaway.com/rsrcs-crs/traveler/react-urgency-messaging';

export const EdapEventFields = {
    EVENT: 'generic.event',
    CATEGORY: 'Urgency Messages',
    DESTINATION_MESSAGE_LABEL: 'DestinationMessage',
    UNIT_MESSAGE_LABEL: 'UnitMessage'
};

export const types = {
    [SMALL]: 'grayscale',
    [MEDIUM]: 'color',
    [LARGE]: 'animation',
    [SMALL_COLOR]: 'color_small'
};

export const sizes = {
    [SMALL]: '16px',
    [MEDIUM]: '24px',
    [LARGE]: '32px'
};

export const buildImageUrl = (type) => `${CDN_URL}/${Images[type]}`;

export const buildType = (iconType, iconSize, color) => {
    const size = iconSize === SMALL && color ? SMALL_COLOR : iconSize;
    return `${iconType}_${types[size]}`.toUpperCase();
};

export const getIconProps = (iconType, iconSize, color) => ({
    style: {
        width: sizes[iconSize],
        height: sizes[iconSize]
    },
    src: buildImageUrl(buildType(iconType, iconSize, color))
});
